import {gql} from 'apollo-angular';
export const SEND_COMPANY_PROFILE_QUIZ_QUEST = gql`
  query sendCompanyProfileQuizQuest($clientID: String!, $profileID: Int!) {
    sendCompanyProfileQuizQuest(clientID: $clientID, profileID: $profileID){
      type, message
    }
  }
`;
